'use client';

import { StickyAppCta } from '.';

import { VARIANT_IDENTIFIER } from '@/modules/experiments/config';
import { useExperiments } from '@/modules/experiments/useExperiments';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function StickyAppCtaExperiment() {
  const { web_9163_app_download_cta_on_homepage } = useExperiments([
    'web_9163_app_download_cta_on_homepage',
  ]);
  const [isAuthenticated] = useCurrentUser();

  if (isAuthenticated) {
    return null;
  }
  if (web_9163_app_download_cta_on_homepage !== VARIANT_IDENTIFIER) {
    return null;
  }
  return <StickyAppCta />;
}
